var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdminMachineList',{attrs:{"lockedFilters":{ SupplierIdList: [_vm.$route.params.supplierId] },"hideSupplierFilter":""}})}
var staticRenderFns = []

export { render, staticRenderFns }